import {
  configureStore,
  ThunkAction,
  Action,
} from '@reduxjs/toolkit';
import rootReducer from 'models';
import throttle from 'lodash/throttle';
import merge from 'lodash/merge';
import { APP_ENV } from 'appenv';
import loadState from 'state/loadState';
import saveState from 'state/saveState';
import { twilioPreloadInitialState } from 'models/twilio';
import * as Sentry from '@sentry/react';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => (
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
  ),
  preloadedState: {
    productCategories: {
      selected: loadState(`${APP_ENV}_selectedProductCategoryFilter`),
    },
    firstTimeProfilePictureModal: {
      open: !(loadState(`${APP_ENV}_skipProfilePictureModal`)),
      avatarImage: null,
      skipped: loadState(`${APP_ENV}_skipProfilePictureModal`) ?? false,
    },
    bookmarks: loadState(`${APP_ENV}_selectedBookmarks`),
    twilioPreload: merge(twilioPreloadInitialState, loadState(`${APP_ENV}_twilioPreload`)),
  },
  enhancers: [sentryReduxEnhancer],
});

store.subscribe(throttle(() => {
  saveState(`${APP_ENV}_selectedProductCategoryFilter`, store.getState().productCategories.selected);
  saveState(`${APP_ENV}_selectedBookmarks`, store.getState().bookmarks);
  saveState(`${APP_ENV}_skipProfilePictureModal`, store.getState().firstTimeProfilePictureModal.skipped);
  saveState(`${APP_ENV}_twilioPreload`, store.getState().twilioPreload);
}, 3000));

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
